import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuienesSomos from './components/QuienesSomos';
import VideoInstitucional from './components/VideoInstitucional';
import Servicios from './components/Servicios';
import Empleabilidad from './components/Empleabilidad';
import Programas from './components/Programas';
import Beneficios from './components/Beneficios';
import Noticias from './components/Noticias';
import Galeria from './components/Galeria';
import Testimonios from './components/Testimonios';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import WaveDivider from './components/WaveDivider';
import MascotaFlotante from './components/MascotaFlotante';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <WaveDivider topColor="#1a1a1a" bottomColor="#ffffff" variant={1} height={90} />
      <QuienesSomos />
      <WaveDivider topColor="#ffffff" bottomColor="#2d7aa6" variant={2} height={90} />
      <VideoInstitucional />
      <WaveDivider topColor="#2d7aa6" bottomColor="#F8F9FA" variant={3} height={90} />
      <Servicios />
      <WaveDivider topColor="#2d7aa6" bottomColor="#F4F8FB" variant={4} height={90} />
      <Empleabilidad />
      <WaveDivider topColor="#2d7aa6" bottomColor="#ffffff" variant={1} height={90} />
      <Programas />
      <WaveDivider topColor="#2d7aa6" bottomColor="#f5f7fa" variant={2} height={70} />
      <Beneficios />
      <WaveDivider topColor="#2d7aa6" bottomColor="#FAFAFA" variant={3} height={90} />
      <Noticias />
      <WaveDivider topColor="#2d7aa6" bottomColor="#ffffff" variant={4} height={90} />
      <Galeria />
      <WaveDivider topColor="#2d7aa6" bottomColor="#FAF9F7" variant={1} height={90} />
      <Testimonios />
      <WaveDivider topColor="#2d7aa6" bottomColor="#ffffff" variant={2} height={90} />
      <Contacto />
      <WaveDivider topColor="#ffffff" bottomColor="#1A3A52" variant={3} height={90} />
      <Footer />
      <MascotaFlotante />
    </div>
  );
}
